import React from 'react'
import { isMobile } from 'react-device-detect'

import {
  DailyBalanceContainer,
  DaySwitcher,
  DaySwitcherDate,
  DaySwitcherButton,
  ProgressBar,
} from './DailyBalanceStyles'

import {
  HorizontalDivider,
  TextHeaderRow,
  AltTextHeaderRow,
  PostscriptTextRow,
  NutritionalValuesContainer,
  NutritionalValue,
  Value,
  Name,
} from '../../Shared/SharedStyledComponents'

import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'

interface DailyBalanceProps {
  userDailyBalance: any
  date: any
  nextDateBalance: any
  prevDateBalance: any
  calorieGoal: any
  fatGoal: any
  carbsGoal: any
  proteinGoal: any
  calorieCurrent: any
  userPlanData: any
}

const DailyBalance: React.FC<DailyBalanceProps> = ({
  userDailyBalance,
  date,
  nextDateBalance,
  prevDateBalance,
  calorieGoal,
  fatGoal,
  carbsGoal,
  proteinGoal,
  calorieCurrent,
  userPlanData,
}) => {
  const calculateProgress = (calorieCurrent: any, calorieGoal: any) => {
    if (calorieCurrent && calorieGoal) {
      return (calorieCurrent / calorieGoal) * 100
    }
  }

  return (
    <DailyBalanceContainer>
      <DaySwitcher>
        <DaySwitcherButton prev onClick={prevDateBalance} />
        {/* <DaySwitcherDate> {date} </DaySwitcherDate> */}
        <GenericTextSpan fSize={isMobile ? '1.4rem' : '0.8rem'}>
          {date}
        </GenericTextSpan>
        <DaySwitcherButton next onClick={nextDateBalance} />
      </DaySwitcher>
      {/* <HorizontalDivider /> */}
      <GenericTextSpan
        className="daily-balance-header"
        fSize={isMobile ? '1.7rem' : '1.2rem'}
        margin={isMobile ? '8% 0 0 0' : ' 30% 0 0 0'}
      >
        Bilans dzienny
      </GenericTextSpan>

      <GenericRow margin={isMobile ? ' 10% 0 0 6%' : ' 10% 0 0 0'}>
        <GenericTextSpan
          className={'color-green '}
          fSize={isMobile ? ' 2.5rem' : '1.8rem'}
        >
          {`${
            calorieCurrent == null || calorieCurrent == undefined
              ? '0'
              : calorieCurrent
          } `}
        </GenericTextSpan>
        <GenericTextSpan margin={'0 0 0 8%'} fSize={'1rem'}>
          kcal
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericTextSpan
          opacity={'0.7'}
          margin={'3% 0 0 0%'}
          fSize={isMobile ? '1.2rem' : '0.8rem'}
        >
          / {calorieGoal} kcal
        </GenericTextSpan>
      </GenericRow>

      {/* <AltTextHeaderRow fontSize={24}>
        {`${
          calorieCurrent == null || calorieCurrent == undefined
            ? '0'
            : calorieCurrent
        } kcal`}
      </AltTextHeaderRow> */}
      {/* <PostscriptTextRow>
        /{calorieGoal ? `${calorieGoal} kcal` : `0 kcal`}
      </PostscriptTextRow> */}

      <ProgressBar progress={calculateProgress(calorieCurrent, calorieGoal)} />
      <NutritionalValuesContainer>
        <NutritionalValue>
          <GenericTextSpan
            fSize={isMobile ? '1.35rem' : '1rem'}
            fWeight={'bold'}
            className="color-green"
          >
            {userPlanData && userPlanData.total_kcal.protein == null
              ? `0 g`
              : userPlanData && userPlanData.total_kcal.protein
              ? `${userPlanData.total_kcal.protein} g`
              : null}{' '}
          </GenericTextSpan>

          <GenericTextSpan fSize={isMobile ? '1.15rem ' : '0.9rem'}>
            Białko
          </GenericTextSpan>
        </NutritionalValue>
        <NutritionalValue>
          <GenericTextSpan
            fWeight={'bold'}
            fSize={isMobile ? '1.35rem' : '1rem'}
            className="color-green"
          >
            {' '}
            {userPlanData && userPlanData.total_kcal.carbs == null
              ? `0 g`
              : userPlanData && userPlanData.total_kcal.carbs
              ? `${userPlanData.total_kcal.carbs} g`
              : null}{' '}
          </GenericTextSpan>
          <GenericTextSpan fSize={isMobile ? '1.15rem ' : '0.9rem'}>
            Węglowodany
          </GenericTextSpan>
        </NutritionalValue>
        <NutritionalValue>
          <GenericTextSpan
            fWeight={'bold'}
            fSize={isMobile ? '1.35rem' : '1rem'}
            className="color-green"
          >
            {' '}
            {userPlanData && userPlanData.total_kcal.fat == null
              ? `0 g`
              : userPlanData && userPlanData.total_kcal.fat
              ? `${userPlanData.total_kcal.fat} g`
              : null}{' '}
          </GenericTextSpan>
          <GenericTextSpan fSize={isMobile ? '1.15rem ' : '0.9rem'}>
            Tłuszcze
          </GenericTextSpan>
        </NutritionalValue>
      </NutritionalValuesContainer>
    </DailyBalanceContainer>
  )
}

export default DailyBalance
